import React, { FC } from 'react'

import { Column, NavLink, Row, Text } from '../../../components'
import { vendorPath } from '../../../routes'

import { ProductPreviewVendorInfoProps } from './product-preview-vendor-info.types'

export const ProductPreviewVendorInfo: FC<ProductPreviewVendorInfoProps> = ({
  className = '',
  countryCode,
  id = '',
  slug,
  name = ''
}) => {
  return (
    <Column
      fullWidth
      alignItems="flex-start"
      justifyContent="flex-start"
      className={className}
    >
      <Text
        text="Company:"
        tx="vendor.listItem.title"
        preset="h6"
        color="inactive"
      />
      <Row fullWidth justifyContent="space-between">
        <NavLink preset="h5" text={name} to={vendorPath({ id, slug })} />
        {countryCode && <Text text={countryCode} preset="h7" />}
      </Row>
    </Column>
  )
}
